import API from "./API";
import {base_url} from "@/Config";



export default class MediaLibraryAPI extends API {

  
  static controllerName = 'SiteAdmin/MediaLibraryAPI'


  static async getMedia( path, search ) {
    return super.newPost( 'getMedia', [], { path, search } )
  }



  static checkFileExists( path ) {
    return super.newPost( 'checkFileExists', [], { path } )
  }  
  
  static uploadFileBase64Chunk( path, chunk ) {
    return super.newPost( 'uploadFileBase64Chunk', [], { path, chunk } )
  }



  static async renameMedia(path, oldName, newName) {
    await super.newPost( 'renameMedia', [], { path, oldName, newName } )
  }

  static async deleteMedia(path, name) {
    await super.newPost( 'deleteMedia', [], { path, name } )
  }


  static async getProductImages(sku) {
    if (!sku) {
      throw new Error('Missing property "sku".');
    }

    const url = `${base_url}/SiteAdmin/MediaLibraryAPI/getProductImages/${sku}`;
    return await super.get(url);
  }


  static getSubfolders( path ) {
    return super.newPost( 'getSubfolders', [], { path } )
  }

  
  static createFolder( path ) {
    return super.newPost( 'createFolder', [], { path } )
  }


  static deleteFolder( path ) {
    return super.newPost( 'deleteFolder', [], { path } )
  }


  // ----- Access control -----

  // Returns { access: 'public' | 'private', grants: string[] } for the folder at `path`.
  // A folder with no explicit record defaults to 'private' (fail-safe).
  static getFolderAccess( path ) {
    return super.newPost( 'getFolderAccess', [], { path } )
  }

  // Returns a map { [subfolderName]: 'public' | 'private' } for the immediate
  // children of `path`, so the browser can badge them without one call per folder.
  static getSubfolderAccess( path ) {
    return super.newPost( 'getSubfolderAccess', [], { path } )
  }

  // Persists the access setting for the folder at `path`.
  // `grants` is only meaningful when access === 'private' (OR-semantics: a user
  // with privileges matching ANY listed grant is allowed in).
  static setFolderAccess( path, access, grants ) {
    return super.newPost( 'setFolderAccess', [], { path, access, grants } )
  }

  // Replaces the entire per-file public-override list for the folder at `path`
  // (the `.publicfiles` dotfile). Send the FULL desired list every time; this
  // overwrites, it does not merge. `filenames` are bare names in this folder only.
  // The server scrubs/de-dupes/drops leading-dot names, so the returned
  // { publicFiles } is authoritative — re-render from it.
  static setPublicFiles( path, filenames ) {
    return super.newPost( 'setPublicFiles', [], { path, filenames } )
  }
}
